import {XMarkIcon} from "@heroicons/react/24/solid";
import React, {useState} from "react";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";


const ProductBlogPostTitles = ({
                                   titles,
                                   showTitles,
                                   handleTitleSelection
                               }) => {
    const [selectedTitle, setSelectedTitle] = useState(null);

    return (
        <>
            {titles?.length > 0 && showTitles &&
                <div className={'w-full text-left'}>
                    {titles?.map((title, titleIndex) => (
                        <div key={`title-${titleIndex}`}
                             onClick={() => setSelectedTitle(title)}
                             className={`cursor-pointer w-full mb-2 px-3 py-2 border rounded ${title === selectedTitle ? 'border-purple-400 bg-purple-400 text-white font-semibold' : 'border-gray-400 bg-gray-50 hover:bg-purple-100'}`}>
                            <div className={`w-full flex justify-between items-center`}>
                                <div>{title}</div>

                                {title === selectedTitle &&
                                    <div>
                                        <button
                                            className="ml-2 button-gray px-2 py-1 text-sm"
                                            type="button"
                                            onClick={() => {
                                                handleTitleSelection(title);
                                            }}>
                                            Confirm
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    ))}
                </div>
            }
        </>
    )
}

export default ProductBlogPostTitles
